import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// NEW
import Swal from "sweetalert2";

const isAdminPage = () => {
  const { pathname } = window.location;
  return pathname.startsWith("/admin") || pathname.startsWith("/Admin-profile-setting");
};

// Admin pages par har axios request mein adminToken khud lag jata hai
axios.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("adminToken");
  const isLoginCall = config.url?.endsWith("/admin/login");

  if (adminToken && isAdminPage() && !isLoginCall && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

const AppContext = React.createContext();
export const AppProvider = ({ children }) => {
  const navigate = useNavigate();

  const [selectedCategory,    setSelectedCategory]    = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [cartItems,           setCartItems]           = useState([]);
  const [cartCount,           setCartCount]           = useState(0);
  const [wishlistCount,       setWishlistCount]       = useState(0);
  const [notificationCount,   setNotificationCount]   = useState(0);
  const [data,                setData]                = useState([]);
  const [uploadImage,         setUploadImage]         = useState(null);
  const [customizeImage,      setCustomizeImage]      = useState(null);


const baseUrl = "https://moonlit.btsportfolio2026.com/backend/public/api";
  const baseUrlForFiles = "https://moonlit.btsportfolio2026.com/backend/public/storage"; 
    // const baseUrl         = "http://127.0.0.1:8000/api";
  // const baseUrlForFiles = "http://127.0.0.1:8000/storage";

  const getValidToken = () => {
    const t = localStorage.getItem("authToken");
    return t && t !== "undefined" && t !== "null" ? t : null;
  };

  const getSavedCustomer = () => {
    try {
      const c = localStorage.getItem("loggedInCustomer");
      return c && c !== "undefined" && c !== "null" ? JSON.parse(c) : null;
    } catch { return null; }
  };

  const [authToken,  setAuthToken]  = useState(getValidToken());
  const [isLoggedIn, setIsLoggedIn] = useState(!!getValidToken());
  const [customer,   setCustomer]   = useState(getSavedCustomer());

  useEffect(() => {
    if (!authToken) {
      setCustomer(null);
      return;
    }
    axios.get(`${baseUrl}/profile`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((res) => {
        setCustomer(res.data.customer);
        // AppContext ke customer ke sath localStorage bhi sync rakho
        // taake purane, alag-alag localStorage reads (ShoppingCartPage, WishlistPage) bhi sahi data den
        localStorage.setItem("loggedInCustomer", JSON.stringify(res.data.customer));
      })
      .catch(() => {
        setCustomer(null);
        localStorage.removeItem("loggedInCustomer");
      });
  }, [authToken, baseUrl]);

  // NEW
  // ── GLOBAL 401 HANDLER ──────────────────────────────────
  // Token invalid/expired hone par session clear karke sahi login page par bhejta hai:
  // admin pages → /admin/login, baaki → customer /login.
  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          if (isAdminPage()) {
            localStorage.removeItem("adminToken");
            localStorage.removeItem("adminemail");
            localStorage.removeItem("adminUser");
            navigate("/admin/login", { replace: true });
          } else {
            setAuthTokenSafe(null);
            setIsLoggedIn(false);
            setCustomer(null);
            localStorage.removeItem("loggedInCustomer");
            navigate("/login");
          }
        }
        return Promise.reject(error);
      }
    );

    return () => axios.interceptors.response.eject(interceptorId);
  }, [navigate]);
  const storeSelectedCategory    = (c) => setSelectedCategory(c);
  const storeSelectedSubcategory = (s) => setSelectedSubcategory(s);
  const storeSingleCart          = (item) => setCartItems((prev) => [...prev, item]);

  const emailRegex    = /^[A-Za-z0-9]{3,}@[a-z0-9.-]{3,}\.[a-z]{2,}$/;
  const passwordRegex = /^[A-Za-z0-9@#$%^&*!]{7,}$/;
  const nameRegex     = /^[A-Za-z]{3,}$/;

  const regExpChecker = (type, value) => {
    switch (type) {
      case "email":    return emailRegex.test(value)    ? "" : "Invalid Email";
      case "password": return passwordRegex.test(value) ? "" : "Password must be at least 7 characters";
      case "firstname":
      case "lastname": return nameRegex.test(value)     ? "" : "Enter valid name";
      default:         return "";
    }
  };

  const validateProductSelection = (selectedColor, selectedSize, quantity) => {
    if (selectedColor === null) {
      Swal.fire({ icon: "warning", title: "Select Color", text: "Please select a color first" });
      return false;
    }
    if (!selectedSize) {
      Swal.fire({ icon: "warning", title: "Select Size", text: "Please select a size first" });
      return false;
    }
    if (quantity < 1) {
      Swal.fire({ icon: "warning", title: "Invalid Quantity", text: "Please select quantity" });
      return false;
    }
    return true;
  };

  // ── CENTRALIZED LOGIN CHECK ─────────────────────────────
  // Poore app mein ye ek hi jagah se use hoga (ProductCard, CartPage, WishlistPage, etc).
  // Agar customer login nahi hai to warning dikha kar login page bhej deta hai,
  // aur false return karta hai taake calling function wahin ruk jaye (API call na ho).
  //
  // FIX: Ab sirf `authToken` (localStorage token) ko source of truth maana ja raha hai.
  // Pehle `customer?.id` par bhi depend karta tha — lekin `customer` object
  // /profile API se ASYNC load hota hai. Fresh page load par (jaise seedha
  // /products/Women URL kholna), token turant localStorage se mil jata hai
  // lekin `customer` object thodi der baad set hota hai. Us darmiyani waqt
  // mein user click kare to "Login Required" popup baar baar khulta tha
  // chahe woh already logged in ho. Token hi asal proof hai login session
  // valid hone ka, isliye ab sirf wahi check hoga.
  const requireLogin = () => {
    const currentToken = authToken || getValidToken();

    if (currentToken) return true;

    navigate("/login");
    return false;
  };

  const fetchNotificationCount = useCallback(() => {
  if (!customer?.id) return;
  axios
    .get(`${baseUrl}/customer/notification/getnotifications`, {
      params: { customer_id: customer.id },
    })
    .then((res) => {
      const raw = Array.isArray(res.data.notifications) ? res.data.notifications : [];
      setNotificationCount(raw.filter((n) => n.status === "unread").length);
    })
    .catch(() => {});
}, [baseUrl, customer]);

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 15000);
    return () => clearInterval(interval);
  }, [fetchNotificationCount]);

  // Sirf logged-in customer ka cart count fetch karo — guest cart nahi
  useEffect(() => {
    const savedCustomer = getSavedCustomer();
    const customerId    = savedCustomer?.id;

    if (!customerId) {
      setCartCount(0);
      return;
    }

    axios
      .get(`${baseUrl}/customer/cart/viewCart/${customerId}`)
      .then((res) => setCartCount((res.data.carts || []).length))
      .catch(() => setCartCount(0));
  }, []);

  const setAuthTokenSafe = (token) => {
    if (token && token !== "undefined" && token !== "null") {
      localStorage.setItem("authToken", token);
      setAuthToken(token);
    } else {
      localStorage.removeItem("authToken");
      localStorage.removeItem("loggedInCustomer");
      setAuthToken(null);
    }
  };

  return (
    <AppContext.Provider
      value={{
        selectedCategory,
        selectedSubcategory,
        validateProductSelection,
        cartItems,
        cartCount,
        wishlistCount,
        notificationCount,
        data,
        uploadImage,
        customizeImage,
        authToken,
        isLoggedIn,
        customer,
        setSelectedCategory,
        setSelectedSubcategory,
        setCartItems,
        setCartCount,
        setWishlistCount,
        setNotificationCount,
        setData,
        setUploadImage,
        setCustomizeImage,
        setAuthToken: setAuthTokenSafe,
        setIsLoggedIn,
        setCustomer,
        baseUrl,
        baseUrlForFiles,
        storeSingleCart,
        storeSelectedCategory,
        storeSelectedSubcategory,
        regExpChecker,
        fetchNotificationCount,
        requireLogin,
        navigate,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;